var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FxDapHttpClient } from '../../../fx-http-client';
import { TranslateService } from '@ngx-translate/core';
import { DwRoutingMessageService, DwUserService } from '@webdpt/framework';
import { DwTreeNode } from 'app/implementation/shared/tree/dw-tree-node';
import { FxModalService } from '../../fx-modal/fx-modal.service';
import { DwModalRef } from 'ng-quicksilver';
import { FxUserInfoService } from '../../../../auth/fx-auth/fx-user-info.service';
import { DwTreeComponent } from 'app/implementation/shared/tree/dw-tree.component.js';
export var USER_EDIT_ACTION;
(function (USER_EDIT_ACTION) {
    USER_EDIT_ACTION["ADD"] = "1";
    USER_EDIT_ACTION["REMOVE"] = "2";
})(USER_EDIT_ACTION || (USER_EDIT_ACTION = {}));
var RoleAndUserRelationshipSettingComponent = /** @class */ (function () {
    function RoleAndUserRelationshipSettingComponent(modal, http, dwMessage, fxModalService, translateService, userService, fxUserService, el, render) {
        this.modal = modal;
        this.http = http;
        this.dwMessage = dwMessage;
        this.fxModalService = fxModalService;
        this.translateService = translateService;
        this.userService = userService;
        this.fxUserService = fxUserService;
        this.el = el;
        this.render = render;
        // 搜索文本框
        this.searchValue = '';
        // 组织树
        this.nodes = [];
        // 选择组织节点
        this.currentNode = {};
        // 待选择用户搜索
        this.orgUserSearchValue = '';
        // 已选择用户搜索
        this.selectedUserSearchValue = '';
        // 组织下可选用户
        this.orgUsers = [];
        this.filteredOrgUsers = [];
        // 已选择的用户
        this.selectedUsers = [];
        this.filteredSelectedUsers = [];
        this.defaultColDef = {
            suppressSorting: true,
            suppressFilter: true,
            suppressMovable: true,
            editable: false
        };
        this.columnDefs1 = [];
        this.columnDefs2 = [];
        this.gridContext1 = {};
        this.gridContext2 = {};
        console.log(userService);
    }
    RoleAndUserRelationshipSettingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getOrgData(this.userService.userInfo['c_user']).subscribe(function (data) {
            // this.nodes = data.map(item => {
            //   return new DwTreeNode(item);
            // });
            var arr = [];
            data.forEach(function (item) {
                arr.push(new DwTreeNode(item));
            });
            _this.nodes = arr;
        });
        this.columnDefs1 = [
            {
                headerName: '',
                width: 55,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                checkboxSelection: true
            },
            {
                headerName: this.translateService.instant('abj001'),
                field: 'abj001',
                width: 100,
            },
            {
                headerName: this.translateService.instant('abj001_n1'),
                field: 'abj001_n1',
                width: 100,
            },
            {
                headerName: this.translateService.instant('abjldept'),
                field: 'abjldept',
                width: 100,
            },
            {
                headerName: this.translateService.instant('abjlorg_n1'),
                field: 'abjlorg_n1',
                width: 100,
            },
            {
                headerName: this.translateService.instant('abjlorg'),
                field: 'abjlorg',
                width: 100,
            },
            {
                headerName: this.translateService.instant('abjlorg_n1'),
                field: 'abjlorg_n1',
                width: 100,
            }
        ];
        /**
         abk001: "10058"
         abk001_n1: "丁浩"
         abkldept: null
         abkldept_n1: null
         abklorg: "100001"
         abklorg_n1: "总部"
         */
        this.columnDefs2 = [
            {
                headerName: '',
                width: 55,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                checkboxSelection: true
            },
            {
                headerName: this.translateService.instant('abk001'),
                field: 'abk001',
                width: 100,
            },
            {
                headerName: this.translateService.instant('abk001_n1'),
                field: 'abk001_n1',
                width: 100,
            },
            {
                headerName: this.translateService.instant('abkldept'),
                field: 'abkldept',
                width: 100,
            },
            {
                headerName: this.translateService.instant('abkldept_n1'),
                field: 'abkldept_n1',
                width: 100,
            },
            {
                headerName: this.translateService.instant('abklorg'),
                field: 'abklorg',
                width: 100,
            },
            {
                headerName: this.translateService.instant('abklorg_n1'),
                field: 'abklorg_n1',
                width: 100,
            }
        ];
    };
    RoleAndUserRelationshipSettingComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        console.log(this.el);
        console.log(this.render);
        setTimeout(function () {
            try {
                var fmc = _this.el.nativeElement.getElementsByClassName('fx-modal-container')[0];
                // fmc.parentNode.parentNode.parentNode.set
                _this.render.setStyle(fmc, 'background', '#fff');
                _this.render.setStyle(fmc.parentNode.parentNode.parentNode, 'background', 'rgba(0,0,0,0)');
                _this.render.setStyle(fmc.parentNode.parentNode.parentNode, 'box-shadow', 'none');
                _this.render.setStyle(fmc.parentNode.parentNode.parentNode.getElementsByClassName('ant-modal-close-x')[0], 'display', 'none');
                _this.render.setStyle(fmc.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode, 'background', 'rgba(0,0,0,0)');
            }
            catch (e) {
                console.error(e);
            }
        }, 300);
    };
    // private dwEventOnDragStart($event: any): void {}
    // private dwEventOnDragEnter($event: any): void {}
    // private dwEventOnDragLeave($event: any): void {}
    // private dwEventOnDragOver($event: any): void {}
    // private dwEventOnDrop($event: any): void {}
    // private dwEventOnDragEnd($event: any): void {}
    // private dwEventExpandChange($event: any): void {}
    // private dwEventSearchValueChange($event: any): void {}
    RoleAndUserRelationshipSettingComponent.prototype.dwClick = function ($event) {
        console.log($event);
        if (this.currentNode && this.currentNode.key === $event.node.key) {
            return;
        }
        this.currentNode = $event.node;
        this.showUserInfo();
    };
    RoleAndUserRelationshipSettingComponent.prototype.showUserInfo = function () {
        var _this = this;
        this.showRoleUserInfo(this.role_id, this.currentNode.key).then(function () {
            _this.showOrgUserInfo(_this.currentNode.key);
        });
    };
    RoleAndUserRelationshipSettingComponent.prototype.getOrgData = function (userNo) {
        var _this = this;
        return Observable.create(function (observer) {
            var entNo = _this.fxUserService.userInfo['c_ent'];
            _this.http.post('A/IACommonService/getOrgTree', { param: { user_no: userNo, entNo: entNo } }).subscribe(function (data) {
                if (data.success && data.data) {
                    observer.next(data.data);
                }
                else {
                    observer.error(data);
                }
                observer.complete();
            }, function (error) {
                observer.error(error);
            });
        });
    };
    RoleAndUserRelationshipSettingComponent.prototype.getOrgUserData = function (orgId) {
        var _this = this;
        return Observable.create(function (observer) {
            _this.http.post('A/IFxai023Service/getUserListByOrg', { param: { org_no: orgId } }).subscribe(function (data) {
                if (data.success && data.data) {
                    observer.next(data.data);
                }
                else {
                    observer.error(data);
                }
                observer.complete();
            }, function (error) {
                observer.error(error);
            });
        });
    };
    RoleAndUserRelationshipSettingComponent.prototype.getRoleUserData = function (roleId, orgId) {
        var _this = this;
        return Observable.create(function (observer) {
            _this.http.post('A/IFxai023Service/getUserListByRole', { param: { role_no: roleId, org_no: orgId } }).subscribe(function (data) {
                if (data.success && data.data) {
                    observer.next(data.data);
                }
                else {
                    observer.error(data);
                }
                observer.complete();
            }, function (error) {
                observer.error(error);
            });
        });
    };
    RoleAndUserRelationshipSettingComponent.prototype.searchOrgUser = function () {
        var _this = this;
        this.filteredOrgUsers = ('' === this.orgUserSearchValue)
            ? this.orgUsers
            : this.orgUsers.filter(function (item) {
                return JSON.stringify(item).indexOf(_this.orgUserSearchValue) > -1;
            });
    };
    RoleAndUserRelationshipSettingComponent.prototype.searchSelectedUser = function () {
        var _this = this;
        this.filteredSelectedUsers = ('' === this.selectedUserSearchValue)
            ? this.selectedUsers
            : this.selectedUsers.filter(function (item) {
                return JSON.stringify(item).indexOf(_this.selectedUserSearchValue) > -1;
            });
    };
    RoleAndUserRelationshipSettingComponent.prototype.showOrgUserInfo = function (orgId) {
        return __awaiter(this, void 0, void 0, function () {
            var orgUsers, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filteredOrgUsers = [];
                        // this.filteredSelectedUsers = [];
                        this.orgUsers = [];
                        // this.selectedUsers = [];
                        this.orgUserSearchValue = '';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getOrgUserData(orgId).toPromise()];
                    case 2:
                        orgUsers = _a.sent();
                        this.orgUsers = orgUsers.filter(function (orgUser) {
                            return _this.selectedUsers.findIndex(function (selectedUser) {
                                return orgUser.abj001 === selectedUser.abk001;
                            }) < 0;
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.searchOrgUser();
                        return [2 /*return*/];
                }
            });
        });
    };
    RoleAndUserRelationshipSettingComponent.prototype.showRoleUserInfo = function (roleId, orgId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // this.filteredOrgUsers = [];
                        this.filteredSelectedUsers = [];
                        // this.orgUsers = [];
                        this.selectedUsers = [];
                        // this.orgUserSearchValue = '';
                        this.selectedUserSearchValue = '';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.getRoleUserData(roleId, orgId).toPromise()];
                    case 2:
                        _a.selectedUsers = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _b.sent();
                        console.error(e_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.searchSelectedUser();
                        return [2 /*return*/];
                }
            });
        });
    };
    // grid多语系
    RoleAndUserRelationshipSettingComponent.prototype.localTextFunc = function (key) {
        // return this.translateService.instant(key);
    };
    RoleAndUserRelationshipSettingComponent.prototype.onGrid1Ready = function (params) {
        this.gridApi1 = params.api;
    };
    RoleAndUserRelationshipSettingComponent.prototype.onGrid2Ready = function (params) {
        this.gridApi2 = params.api;
    };
    RoleAndUserRelationshipSettingComponent.prototype.addSelectedItem = function () {
        var _this = this;
        var selectRows = this.gridApi1.getSelectedRows().map(function (item) {
            return {
                user_no: item.abj001
            };
        });
        selectRows = selectRows.filter(function (item) {
            return _this.selectedUsers.findIndex(function (user) { return user.abk001 === item.user_no; }) < 0;
        });
        if (selectRows.length > 0) {
            this.addUserByRole(selectRows, this.role_id, USER_EDIT_ACTION.ADD).subscribe(function (success) {
                console.log('success', success);
                _this.dwMessage.info('修改成功');
                _this.showUserInfo();
            }, function (error) {
                _this.fxModalService.confirm(error);
                _this.showUserInfo();
            });
        }
    };
    RoleAndUserRelationshipSettingComponent.prototype.removeSelectedItem = function () {
        var _this = this;
        var selectRows = this.gridApi2.getSelectedRows().map(function (item) {
            return {
                user_no: item.abk001
            };
        });
        selectRows = selectRows.filter(function (item) {
            return _this.orgUsers.findIndex(function (user) { return user.abj001 === item.user_no; }) < 0;
        });
        if (selectRows.length > 0) {
            this.addUserByRole(selectRows, this.role_id, USER_EDIT_ACTION.REMOVE).subscribe(function (success) {
                console.log('success', success);
                _this.dwMessage.info('修改成功');
                _this.showUserInfo();
            }, function (error) {
                _this.fxModalService.confirm(error);
                _this.showUserInfo();
            });
        }
    };
    RoleAndUserRelationshipSettingComponent.prototype.addUserByRole = function (users, roleId, action) {
        var _this = this;
        return Observable.create(function (observer) {
            _this.http.post('A/IFxai023Service/updUserListByRole', {
                param: {
                    role_no: roleId,
                    type: action,
                    user_list: users
                }
            }).subscribe(function (data) {
                if (data.success) {
                    observer.next(data);
                }
                else {
                    observer.error(data);
                }
                observer.complete();
            }, function (error) {
                observer.error(error);
            });
        });
    };
    RoleAndUserRelationshipSettingComponent.prototype.onClickContinue = function () {
        this.modal.triggerOk();
    };
    return RoleAndUserRelationshipSettingComponent;
}());
export { RoleAndUserRelationshipSettingComponent };
